// [2026-03-09] GDPR cookie consent: localStorage helpers
const STORAGE_KEY = "uz.cookieConsent";

export type ConsentValue = "accepted" | "declined";

export interface ConsentRecord {
  value: ConsentValue;
  updatedAt: string; // ISO date
}

/** Read stored consent from localStorage (null if not yet decided) */
export function getCookieConsent(): ConsentRecord | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as ConsentRecord;
  } catch {
    return null;
  }
}

/** Persist consent decision to localStorage */
export function setCookieConsent(value: ConsentValue): ConsentRecord {
  const record: ConsentRecord = { value, updatedAt: new Date().toISOString() };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  return record;
}
